/**
 * Pure display helpers for Meditation Achievements Admin (Phase 1).
 * Kept separate for unit testing without React Router.
 */

export const formatTriggerConfig = (config) => {
  if (config == null) return '—';
  if (typeof config !== 'object') return String(config);
  try {
    return JSON.stringify(config, null, 2);
  } catch {
    return String(config);
  }
};

export const summarizeTriggerConfig = (config) => {
  if (!config || typeof config !== 'object') return '—';
  if (config.threshold != null) return `threshold: ${config.threshold}`;
  if (config.count != null) return `count: ${config.count}`;
  if (config.key != null) return `key: ${config.key}`;
  if (config.month != null && config.day != null) {
    return `${config.month}/${config.day}`;
  }
  if (config.session_type != null) return `type: ${config.session_type}`;
  if (Array.isArray(config.session_types)) {
    return `types: ${config.session_types.join(', ')}`;
  }
  if (config.start_hour != null && config.end_hour != null) {
    return `hours ${config.start_hour}–${config.end_hour}`;
  }
  const keys = Object.keys(config);
  if (!keys.length) return '{}';
  return keys.slice(0, 3).join(', ') + (keys.length > 3 ? '…' : '');
};

export const buildAchievementListBody = ({
  page = 1,
  pageSize = 20,
  searchtext = '',
  filters = {},
} = {}) => {
  const cleanFilters = {};
  Object.entries(filters || {}).forEach(([key, val]) => {
    if (val === '' || val === undefined || val === null) return;
    if (val === 'true') cleanFilters[key] = true;
    else if (val === 'false') cleanFilters[key] = false;
    else cleanFilters[key] = val;
  });

  return {
    searchtext: String(searchtext || '').trim(),
    pagination: {
      page: Number(page) || 1,
      pageSize: Number(pageSize) || 20,
      sort: { order: 1, badge_number: 1, _id: 1 },
      filters: cleanFilters,
      projection: {},
    },
  };
};
